import PropTypes from "prop-types";
import { NavLink as RouterLink } from "react-router-dom";
import { Box, List, ListItemText, Typography, Divider } from "@mui/material";
import { StyledNavItem, StyledNavItemIcon } from "./styles";

NavSection.propTypes = {
  data: PropTypes.array,
  collapse: PropTypes.bool,
  title: PropTypes.string,
};

export default function NavSection({ data = [], collapse = false, title, ...other }) {
  // Return null if no data to render
  if (data.length === 0) {
    return null;
  }

  return (
    <Box {...other}>
      {title && !collapse && (
        <Typography
          variant="overline"
          sx={{
            pl: 3.5, // Align with text after icon (icon width + spacing)
            pr: 2,
            py: 1,
            pb: 0,
            color: 'text.secondary',
            display: 'block',
            fontSize: '0.65rem',
            fontWeight: 'fontWeightBold',
            textTransform: 'uppercase',
            letterSpacing: 1.2,
            opacity: 0.72
          }}
        >
          {title}
        </Typography>
      )}
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} collapse={collapse} />
        ))}
      </List>
      <Divider
        sx={{
          mx: 2,
          my: 1,
          opacity: collapse ? 0 : 1,
          transition: "opacity 0.2s ease-in-out"
        }}
      />
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
  collapse: PropTypes.bool,
};

function NavItem({ item, collapse }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        justifyContent: collapse ? "center" : "flex-start",
        "&.active": {
          color: "text.primary",
          bgcolor: "action.selected",
          fontWeight: "fontWeightBold",
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      {!collapse && (
        <ListItemText
          disableTypography
          primary={title}
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        />
      )}

      {!collapse && info && info}
    </StyledNavItem>
  );
}
